import { Component, input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { FLIGHT_FUEL_FIELDS, FuelGroup, MaxTank } from "../../fuel-row/fuel-row";
import { FuelRowComponent } from "../../fuel-row/fuel-row.component";

/** The fuel the flight itself keeps, in one line like a refuel before the first flight. */
@Component({
    selector: "app-fuel-group",
    imports: [TranslatePipe, FuelRowComponent],
    templateUrl: "./fuel-group.component.html",
    styleUrl: "../../../edit-fields.scss",
})
export class FuelGroupComponent {
    readonly group = input.required<FuelGroup>();
    readonly units = input.required<string[]>();
    readonly maxTank = input<MaxTank>(null);

    readonly fields = FLIGHT_FUEL_FIELDS;
}
